import React, { useState, useContext, useEffect } from "react";
import { useBoolean } from "react-hanger";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import AddressForm from "../../../common/address-form";
import { EditCompanyContext } from "components/common/companies/contexts/admin-edit-company-context";
import { fetchLocationFlags } from "modules/companies";

const Locations = () => {
  const { addresses, onDeleteAddress, onSaveAddress, basicInfo } =
    useContext(EditCompanyContext);
  const showAddressForm = useBoolean(false);
  const [locationFlags, setLocationFlags] = useState([]);
  const [editAddress, setEditAddress] = useState(null);

  const makeAddress = (address) => {
    let addressLine = address.address_line_1;

    if (!["", null].includes(address.address_line_2))
      addressLine += `, ${address.address_line_2}`;

    addressLine += ` ${address.city}, ${address.state} ${address.postal_code}`;

    return addressLine;
  };

  const afterAddressSave = () => {
    setEditAddress(null);
    showAddressForm.setFalse();
  };

  const saveAddress = (address) => {
    onSaveAddress(address).then(afterAddressSave);
  };

  const cancelEdit = () => {
    setEditAddress(null);
    showAddressForm.setFalse();
  };

  useEffect(() => {
    fetchLocationFlags()
      .then((flags) => {
        setLocationFlags(flags);
      })
      .catch((error) => {
        console.error("Error fetching location flags:", error);
      });
  }, []);

  return (
    <div>
      <div className="col-md-12">
        {addresses.value.map((address) => {
          return (
            <div key={address.id} className="card p-3 mb-3">
              {editAddress !== null && editAddress.id === address.id ? (
                <AddressForm
                  address={editAddress}
                  onSaveAddress={saveAddress}
                  onCancel={cancelEdit}
                  locationFlags={locationFlags}
                />
              ) : (
                <div className="d-flex">
                  <div>
                    {address.description && (
                      <span className="mr-2">
                        <strong>{address.description}:&nbsp;</strong>
                      </span>
                    )}
                    <span>{makeAddress(address)}</span>

                    {address.is_primary && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip className="cashflow-tooltip">
                            Primary Address
                          </Tooltip>
                        }
                      >
                        <span className="ms-2">
                          <i className="bi bi-star text-warning"></i>
                        </span>
                      </OverlayTrigger>
                    )}
                    {address.location_flags &&
                      Object.entries(address.location_flags).map(
                        ([flag, value]) =>
                          value && (
                            <span
                              key={flag}
                              className="badge incentive-type-badge ms-1"
                            >
                              {flag
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (l) => l.toUpperCase())}
                            </span>
                          )
                      )}
                  </div>
                  <div className="ms-auto d-flex align-self-start flex-wrap">
                    <div className="btn-group">
                      <button
                        className="btn btn-light"
                        onClick={() => setEditAddress(address)}
                      >
                        Edit
                      </button>
                      {!address.is_primary && (
                        <button
                          className="btn btn-action mx-1"
                          onClick={() => onDeleteAddress(address)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {showAddressForm.value ? (
        <div className="col-md-12">
          <div className="card mb-3 p-3">
            <AddressForm onSaveAddress={saveAddress} onCancel={cancelEdit} />
          </div>
        </div>
      ) : (
        <button className="btn-attach mb-3" onClick={showAddressForm.setTrue}>
          Add Location
        </button>
      )}
    </div>
  );
};

export default Locations;
